import React from 'react';

const ForbiddenPage = () => (
    <div className='text-center mt-6'>
        <h1>Brak uprawnień</h1>
        <p>Nie masz dostępu do tej strony.</p>
    </div>
);

export const NotFoundPage = () => (
    <div className='text-center mt-6' >
        <h1>404</h1>
        <p>Strona nie została znaleziona.</p>
    </div>
);

export default ForbiddenPage; 